export const FORMAT_WARNING_TOOLTIP_POPPER_PROPS = {
  disablePortal: false,
  popperOptions: { strategy: 'fixed' },
  style: { zIndex: 1301 },
};
